import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';

const pinApi = api.injectEndpoints({
  endpoints: (build) => ({
    pinSend: build.mutation<
      ApiResponse<unknown>,
      {
        accountId: number;
        cardId: number;
      }
    >({
      query: ({ accountId, cardId }) => ({
        url: `private/river/${accountId}/card/${cardId}/get-pin`,
        method: 'POST',
      }),
    }),
    pinResend: build.mutation<
      ApiResponse<unknown>,
      {
        accountId: number;
        cardId: number;
      }
    >({
      query: ({ accountId, cardId }) => ({
        url: `private/river/${accountId}/card/${cardId}/get-pin/resend-token`,
        method: 'POST',
      }),
    }),
    pinSign: build.mutation<
      ApiResponse<{ pin: string }>,
      {
        accountId: number;
        cardId: number;
        code?: number | string;
        google2FaCodeFromUser?: number | string;
        headers?: Record<string, string>;
      }
    >({
      query: ({ accountId, cardId, code, google2FaCodeFromUser, headers }) => ({
        url: `private/river/${accountId}/card/${cardId}/get-pin/sign`,
        method: 'POST',
        params: { code, google2FaCodeFromUser },
        headers,
      }),
    }),
  }),
});

export const { usePinSendMutation, usePinResendMutation, usePinSignMutation } = pinApi;

export default pinApi;
